module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between px-5"
  }, [_c('div'), _vm._v(" "), _c('h3', {
    staticClass: "my-4"
  }, [_vm._v("TravelTaiwan " + _vm._s(_vm.$t('list_of_class')))]), _vm._v(" "), _c('img', {
    staticClass: "back-icon pointer my-4",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "src": require("../../../../assets/image/icon/close_lesson.png")
    },
    on: {
      "click": _vm.previousPage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "my-5 list-box"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "menu-box",
      on: {
        "click": function($event) {
          return _vm.goPage(item.id)
        }
      }
    }, [_c('h3', {
      staticClass: "my-auto py-2"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0df9faaf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/tw/record/ClassList.vue
// module id = 749
// module chunks = 3